export default "__VITE_ASSET__bJZdZt5h__"